/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SterWebsiteModelPortalDateSpan
 */
export interface SterWebsiteModelPortalDateSpan {
  /**
   *
   * @type {Date}
   * @memberof SterWebsiteModelPortalDateSpan
   */
  from: Date;
  /**
   *
   * @type {Date}
   * @memberof SterWebsiteModelPortalDateSpan
   */
  to: Date;
}

export function SterWebsiteModelPortalDateSpanFromJSON(
  json: any
): SterWebsiteModelPortalDateSpan {
  return SterWebsiteModelPortalDateSpanFromJSONTyped(json, false);
}

export function SterWebsiteModelPortalDateSpanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SterWebsiteModelPortalDateSpan {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    from: new Date(json["from"]),
    to: new Date(json["to"]),
  };
}

export function SterWebsiteModelPortalDateSpanToJSON(
  value?: SterWebsiteModelPortalDateSpan | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    from: value.from.toISOString(),
    to: value.to.toISOString(),
  };
}
